import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { querySelector } from '../../utils';

const propTypes = exact({
  name: PropTypes.string.isRequired,
  /* eslint-disable react/no-unused-prop-types */
  districtId: PropTypes.number,
  /* eslint-disable react/no-unused-prop-types */
  data: PropTypes.object,
  departments: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
});

export class DepartmentInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnToggle = this.handleOnToggle.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleCancel() {
    this.handleChange(null);
  }

  handleChange(data) {
    this.props.onChange({
      target: {
        name: this.props.name,
        value: data,
      },
    });
  }

  handleOnFocus() {
    this.setState({
      open: true,
    });
  }

  handleOnToggle(open) {
    this.setState({
      open,
    });
  }

  render() {
    const { departments, value } = this.props;
    const { open } = this.state;
    return (
      <div>
        <InputGroup>
          {
            /*
              The on mouse down prevents the 'onClick' from firing. This was toggling the dropdown
              twice. If you have a better way of prevent the double toggle by all means implement
              it.
            */
          }
          <DropdownList
            inputProps={{
              className: 'form-control',
            }}
            filter="contains"
            allowCreate="onFilter"
            value={value}
            data={departments}
            open={open}
            onFocus={this.handleOnFocus}
            onToggle={this.handleOnToggle}
            onCreate={this.handleCreate}
            onChange={this.handleChange}
            onMouseDown={(e) => { e.preventDefault(); }}
            valueField="id"
            textField="name"
          />
          <InputGroup.Button>
            <Button
              name="cancel"
              tabIndex="-1"
              disabled={!value}
              onClick={this.handleCancel}
            >
              <Glyphicon glyph="remove" />
            </Button>
          </InputGroup.Button>
        </InputGroup>
      </div>
    );
  }
}

const GetAllDepartmentsQuery = gql`
  query GetAllDepartments($districtId: Int) {
    all_departments(district_id: $districtId) {
      edges {
        node {
         id
         name
        }
      }
    }
  }
`;

export const marshallData = ({ data, ownProps }) => {
  const departments = querySelector(data, '$.all_departments.edges[*].node', []);
  return {
    ...ownProps,
    data,
    departments,
  };
};

DepartmentInput.propTypes = propTypes;

const withData = graphql(GetAllDepartmentsQuery, { props: marshallData });

export default withData(DepartmentInput);
